// Conector al CRM de la plataforma de Carlos: LISTO pero APAGADO hasta que Carlos acepte (PLAN-NOCHE §2).
// Regla dura: el cotizador NO toca el código ni la base de Carlos. Cuando se prenda, solo MANDA este payload a un
// endpoint que Carlos publique (webhook), con una llave que él dé. Nada más.
import { z } from 'zod';
import { Correo, Etapa, FechaHora, Pesos, Texto, TipoProyecto } from './basicos.ts';
import { EstadoCotizacion } from './cotizacion.ts';

export const PayloadCrmExterno = z.strictObject({
  origen: z.literal('cotizador-solarix'),
  version: z.literal(1),
  cotizacion: z.strictObject({
    folio: z.string(),
    estado: EstadoCotizacion,
    etapa: Etapa,
    tipo: TipoProyecto,
    vendedor_correo: Correo,
    cliente: z.strictObject({
      nombre: Texto(2, 60),
      telefono: z.string().nullable(),
      correo: Correo.nullable(),
      ciudad: Texto(2, 40),
    }),
    kwp_recomendada: z.number().positive().nullable(),
    contado_con_iva: Pesos.nullable(),
    lista_con_iva: Pesos.nullable(),
    actualizada_en: FechaHora,
  }),
});
export type PayloadCrmExterno = z.infer<typeof PayloadCrmExterno>;

export const ResultadoCrmExterno = z.strictObject({
  enviado: z.boolean(),
  id_externo: z.string().max(120).nullable(),
  motivo: z.string().max(500),
});
export type ResultadoCrmExterno = z.infer<typeof ResultadoCrmExterno>;
